import {
  notificationRuleOptionsQuery,
  workspaceNotificationRulesQuery,
} from "@common/api/notification-rules"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { duplicateDefaults } from "../-components/form/schema"
import { RuleMissing } from "../-components/rule-missing"
import { RulePage } from "../-components/rule-page"
import { CREATE_RULES_PERMISSION } from "../-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/notification-rules/duplicate/$ruleId",
)({
  staticData: { breadcrumb: "Duplicate rule" },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      CREATE_RULES_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: async ({ context: { queryClient }, params: { ruleId } }) => {
    const [rules] = await Promise.all([
      queryClient.ensureQueryData(workspaceNotificationRulesQuery()),
      queryClient.ensureQueryData(notificationRuleOptionsQuery()),
    ])
    if (!rules.rules.some((rule) => rule.id === ruleId)) {
      throw redirect({
        to: "/settings/workspace/notification-rules",
        replace: true,
      })
    }
  },
  component: DuplicateRulePage,
})

function DuplicateRulePage(): React.ReactElement {
  const { ruleId } = Route.useParams()
  const { data } = useSuspenseQuery(workspaceNotificationRulesQuery())
  const source = data.rules.find((rule) => rule.id === ruleId)

  return source ? (
    <RulePage
      key={source.id}
      rule={undefined}
      defaults={duplicateDefaults(source)}
    />
  ) : (
    <RuleMissing />
  )
}
